import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';

@Component({
  selector: 'app-report-insert-edit',
  templateUrl: './report-insert-edit.component.html',
  styleUrls: ['./report-insert-edit.component.scss']
})
export class ReportInsertEditComponent implements OnInit {
    @Input() caseId;
    @Input() eCaseId;

  reporttypesList: any;
    NationalityList: any;
    reporterNationalTypeList: any;
    reporterRelationList: any;
    caseDetails: any;
    @Input() isReadOnly: boolean = true;
    @Output() reposrtAdded = new EventEmitter<any>();
    today = new Date();
    currentDate:NgbDateStruct;

    constructor(private dateformat: DateFormatterService, public caseService: CaseService, public lookupService: LookupService, public route: Router, public sharedService: SharedHttpService,) { }
    reportDate: any;
    reporterNationalTypeId: any;
    reportNumber: any;
    reporterNationalityId: any;
    reporterNationalId: any;
    reporterName: any;
    reporterMobileNumber: any;
    reporterMobileNumber2: any;
    reporterRelationId: any;
    address: any;
    reportDetails: any;
    reportTypeId: any;
    @Input() loadDataFP: Observable<any>;
    ngOnInit(): void {
        // this.reporttypesList = this.lookupService.getLockup('reporttypes');
        let url: any = `api/Lookup/GetLookup?key=reporttypes`;
        this.sharedService.get(url).subscribe(result => {
          this.reporttypesList =result;
        });
        this.NationalityList = this.lookupService.getLockup('nationalities');
        this.reporterNationalTypeList = this.lookupService.getLockup('identitytypes');
        this.reporterRelationList = this.lookupService.getLockup('reporterrelations');
        this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);
        this.reportDate = this.dateformat.ToGregorian2(this.currentDate );
        this.loadDataFP.subscribe((data) => {
            setTimeout(() => {
                this.loadData();
            }, 100);

        });

    }


    loadData() {
        // if (this.caseService.case != null || this.caseService.fraudCase != null ) {
        //     this.eCaseId = this.caseService.case.eCaseId;

        //     let url: any = `api/CaseReport/GetCaseReport?eCaseId=${this.eCaseId}`;
        //     this.sharedService.get(url).subscribe(result => {
        //         if (result != null) {
        //             this.reportDate = result.reportDate;
        //             this.reporterNationalityId = result.reporterNationalityId;
        //             this.reporterNationalTypeId = result.reporterNationalTypeId;
        //             this.reporterNationalId = result.reporterNationalId;
        //             this.reportNumber = result.reportNumber;
        //             this.reporterName = result.reporterName;
        //             this.reporterMobileNumber = result.reporterMobileNumber;
        //             this.reporterMobileNumber2 = result.reporterMobileNumber2;
        //             this.reporterRelationId = result.reporterRelationId;
        //             this.reportDetails = result.reportDetails;
        //             this.address = result.address;
        //             this.reportTypeId = result.reportTypeId;


        //         }else{
        //         this.reportDate = undefined;
        //         this.reporterNationalityId = undefined;
        //         this.reporterNationalTypeId = undefined;
        //         this.reporterNationalId = undefined;
        //         this.reportNumber = undefined;
        //         this.reporterName = undefined;
        //         this.reporterMobileNumber = undefined;
        //         this.reporterMobileNumber2 = undefined;
        //         this.reporterRelationId = undefined;
        //         this.reportDetails = undefined;
        //         this.address = undefined;
        //         this.reportTypeId = undefined;

        //     }

        //     });
        // }

      
    }

    numberOnly(event) {
        var inp = String.fromCharCode(event.keyCode);
        let pattern = /^\d+$/;
        if (pattern.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }
    date: any
    SelectedDateChange($event) {
        this.reportDate = this.dateformat.ToGregorian2($event);
    }
    SaveCaseReport() {
        let url = `api/CaseReport/SaveCaseReport`;
        let objectAdded =
        {
            reportDate: this.reportDate,
            reporterNationalTypeId: this.reporterNationalTypeId,
            reportNumber: this.reportNumber,
            reporterNationalityId: this.reporterNationalityId,
            reporterNationalId: this.reporterNationalId,
            reporterName: this.reporterName,
            reporterMobileNumber: this.reporterMobileNumber,
            reporterMobileNumber2: this.reporterMobileNumber2,
            reporterRelationId: this.reporterRelationId,
            address: this.address,
            reportDetails: this.reportDetails,
            reportTypeId: this.reportTypeId,
            eCaseId: this.eCaseId,
            caseId: this.caseId
        };
        this.sharedService.post(url, objectAdded).subscribe((res) => {
            this.reposrtAdded.emit();
            this.sharedService.showSuccessKey("CreatedSuccessfully");
        });
    }

}
